import React from "react";

const Stat_Pie_Charts = () => {
  return (
    <div>
      <h1>Stat Pie Charts</h1>
    </div>
  );
};

export default Stat_Pie_Charts;
